export default "__VITE_ASSET__CBUtZEq0__"